import { config } from 'env_def';
import { inWindowTool } from '../inWindow';
import { WaimaoLabels, Labels } from './labels';
const profile = config('profile');
export const SYSTEM_LANGUAGE = 'system_language';
export const DEFAULT_LANG = 'zh';
export const LangEnum = ['en', 'zh', 'zh-trad'];
if (inWindowTool()) {
    window.missingKeys = [];
}
const missingMap = {};
export const getLabel = locale => {
    try {
        let path;
        let lang = (window && window.systemLang) || 'zh';
        if (typeof locale === 'string') {
            path = locale;
        }
        else {
            path = locale.path;
            lang = locale.lang || 'zh';
        }
        const conf = ((window && window.langJson) || (profile && profile.includes('edm') ? WaimaoLabels : Labels));
        const value = conf.zh ? conf[lang][path] : conf[path];
        if (process.env.NODE_ENV !== 'production' && (value === undefined || value === '')) {
            if (!missingMap[path]) {
                missingMap[path] = true;
                window.missingKeys.push(path);
                console.error(`missing key ${path} not in lang json. window.missingKeys to see detail info`);
            }
        }
        return value || '';
    }
    catch (e) {
        console.warn('[translation] ', e);
        return '';
    }
};
if (inWindowTool() && window) {
    window.getLocalLabel = getLabel;
}
export const initWindowLang = (needAddClass) => {
    if (inWindowTool()) {
        const systemApi = window.apiResposity.getSystemApi();
        const result = systemApi.getSystemLang();
        if (result) {
            window.systemLang = result || 'zh';
        }
        if (needAddClass) {
            if (window.document && document.body && document.body.classList) {
                document.body.classList.add(`lang-${window.systemLang}`);
            }
        }
    }
};
